import React, { useState } from 'react';
import Image1 from '../../../Gemco-Website-Images/projects/BB05_DCP.webp';
import Image2 from '../../../Gemco-Website-Images/projects/mirdif_city_centre.avif';
import Image3 from '../../../Gemco-Website-Images/projects/Cleveland_Clinic_Abu-Dhabi.webp';
import Image4 from '../../../Gemco-Website-Images/projects/C3_Airport.webp';
import Image5 from '../../../Gemco-Website-Images/projects/Al_Nasr_Stadium.webp';
import Image6 from '../../../Gemco-Website-Images/projects/Adcan_Pharma_Abu_dhabi.webp';
import Image7 from '../../../Gemco-Website-Images/projects/Arjaan_Burjuman_Hotel.webp';
import Image8 from '../../../Gemco-Website-Images/projects/Bvlgari_resorts_residenes_Dubai.webp';
import Image9 from '../../../Gemco-Website-Images/projects/BYD_Showroom.webp';
import Image10 from '../../../Gemco-Website-Images/projects/DP_world.webp';
import Image11 from '../../../Gemco-Website-Images/projects/Fire_station_EXPO.webp';
import Image12 from '../../../Gemco-Website-Images/projects/Hilton-_RAK_(retrofit).webp';
import Image13 from '../../../Gemco-Website-Images/projects/Morocco_paviloin_Dubai_EXPO.webp';
import Image14 from '../../../Gemco-Website-Images/projects/Museum_of_the_Future.webp';
import Image15 from '../../../Gemco-Website-Images/projects/Serenia_Residences.webp';
import Image16 from '../../../Gemco-Website-Images/projects/Zaabel_Empower_DCP.webp';
import Image17 from '../../../Gemco-Website-Images/projects/ZARA_Storages_Mall_of_Emirates.webp';
import Image18 from '../../../Gemco-Website-Images/projects/Wynn_Resort_Al_Marjan_Island.webp';
import Image19 from '../../../Gemco-Website-Images/projects/DEC_campus_DWTC.webp';
import Image20 from '../../../Gemco-Website-Images/projects/Ahmed_Seddqui_HQ.webp';
import Image21 from '../../../Gemco-Website-Images/projects/EDEN-HOUSE-THE-PARK.webp';
import Image22 from '../../../Gemco-Website-Images/projects/Fly_Dubai.webp';
import Image23 from '../../../Gemco-Website-Images/projects/Mobility_Pavilion.webp';
import Image24 from '../../../Gemco-Website-Images/projects/IKEA_festival_Plaza.webp';
import Image25 from '../../../Gemco-Website-Images/projects/Dubai_Tram_Depot.webp';
import Image26 from '../../../Gemco-Website-Images/projects/The_D1_tower.webp';
import Image27 from '../../../Gemco-Website-Images/projects/Masdar-Headquarters-Masdar-City-Abu-Dhabi.webp';
import Image28 from '../../../Gemco-Website-Images/projects/C4_Airport.webp';
import Image29 from '../../../Gemco-Website-Images/projects/Hamdan_Sports_complex.webp';
import Image30 from '../../../Gemco-Website-Images/projects/Caesars_&_SA2_Hotels.webp';
import Image31 from '../../../Gemco-Website-Images/projects/City_Walk.webp';
import Image32 from '../../../Gemco-Website-Images/projects/Marsa_Al_Seef.webp';
import Image33 from '../../../Gemco-Website-Images/projects/Il_Primo_tower.webp';
import Image34 from '../../../Gemco-Website-Images/projects/Matoum_International_Airport.webp';
import Image35 from '../../../Gemco-Website-Images/projects/Wasl-Tower.webp';
import Image36 from '../../../Gemco-Website-Images/projects/Danat_Al_Emarat.webp';
import Image37 from '../../../Gemco-Website-Images/projects/deira-city-centre-1.webp';
import Image38 from '../../../Gemco-Website-Images/projects/Dubai_Festival_City.webp';
import Image39 from '../../../Gemco-Website-Images/projects/Dubai_Safari.webp';
import Image40 from '../../../Gemco-Website-Images/projects/Expo_Village.webp';
import Image41 from '../../../Gemco-Website-Images/projects/Marsa_Al_Arab.webp';
import Image42 from '../../../Gemco-Website-Images/projects/Princess_Tower.webp';
import Image43 from '../../../Gemco-Website-Images/projects/RIU_Hotel.webp';
import Image44 from '../../../Gemco-Website-Images/projects/Birmingham_University.webp';
import Image45 from '../../../Gemco-Website-Images/projects/Yas_Mall.webp';
import Image46 from '../../../Gemco-Website-Images/projects/Dubai_Hills_regional_Mall.webp';
import Image47 from '../../../Gemco-Website-Images/projects/Sheikh_Khalifa_Hospital.webp';

import { Link } from "react-router-dom";
import './Project.css';

const projects = [
  {id:1, img: Image8, 
    name: "Bvlgari Resorts", span: "One of the world's most exclusive ultra-luxury resorts, set on a private seahorse-shaped island off Jumeirah Beach Road" ,  
    status: "completed",link: "project/1"},
  {id:2, img: Image14, 
    name: "Museum of the Future", span: "A 78-metre torus-shaped architectural icon developed by Dubai Future Foundation, rated one of the world's most complex buildings",  
    status: "active", link: "project/2"},
  {id:4, img: Image4, 
    name: "Airport", span:"Major expansion works across Concourse 3 and Concourse 4 at Dubai International Airport ", 
    status: "completed",link: "project/3"},
  {id:3, img: Image3, 
    name: "Cleveland Clinic Abu Dhabi", span:"The largest structural steel building in the UAE at 30,000+ tonnes, developed by Mubadala Healthcare", 
    status: "completed",link: "project/4"},
  {id:44, img: Image44, 
    name: "University of Birmingham", span:"The University of Birmingham's first international campus — a 50,000 sqm crescent-shaped building", 
    status: "completed",link: "project/5"},
  {id:16, status: "completed", img: Image16, 
    name: "District Cooling Plant", span:"A new-build district cooling facility serving the Za'abeel precinct, providing centrally generated chilled water"
    , link: "project/6"},
  {id:19, status: "completed", img: Image19, 
    name: "DEC Campus Legacy at DEC Expo", span:"The Dubai Exhibition Centre Campus Legacy project at Expo City Dubai, transforming the former Expo 2020"
    , link: "project/7"},
  {id:8,status: "completed", img: Image1, 
    name: "BB05", span:"Phase 2 expansion of the Empower district cooling plant serving the high-density Business Bay cluster"
    , link: "project/8"},
  {id:9, status: "completed", img: Image9, 
    name: "BYD Showroom", span:"A flagship automotive showroom for BYD — China's leading electric vehicle manufacturer and one of the world's"
    , link: "project/9"},
  {id:10, status: "completed", img: Image10, 
    name: "DP World Fit-out", span:"Interior fit-out of a corporate facility for DP World — one of the world's largest port operators"
    , link: "project/10"},
  {id:11, status: "completed", img: Image11, 
    name: "Fire & Ambulance Expo", span:"A specialised exhibition facility for the UAE's civil defence and emergency services sector, showcasing fire safety"
    , link: "project/11"},
  {id:12, status: "completed", img: Image12, 
    name: "Hilton Resort RAK", span:"A major MEP retrofit project at the Hilton Resort in Ras Al Khaimah — a beachfront property and one of RAK's premier leisure destinations."
    ,link: "project/12"},
  {id:13, status: "completed", img: Image13, 
    name: "Morocco Pavilion Expo", span: "The Kingdom of Morocco's national pavilion at Expo 2020 Dubai — celebrated for its traditional Moroccan architecture"
    , link: "project/13"},
  {id:14, status: "completed", img: Image2, 
    name: "Mirdif City Center", span: "The Kingdom of Morocco's national pavilion at Expo 2020 Dubai — celebrated for its traditional Moroccan architecture and craftsmanship"
    , link: "project/14"},
  {id:15, status: "completed", img: Image15, 
    name: "Serenia Residences", span: "A premium residential development on Palm Jumeirah comprising luxury apartments and penthouses with direct beachfront"
    , link: "project/15"},
  {id:6, status: "completed",img: Image6, 
    name: "ADCAN Pharma", span: "A pharmaceutical manufacturing and storage facility in Abu Dhabi operated by ADCAN — a leading name in the UAE"
    , status: "completed",link: "project/16"},
  {id:17, img: Image17, 
    name: "Zara Storages", span: "A large-scale warehouse and storage facility for Zara — part of Inditex Group, the world's largest fashion retail group" 
    ,status: "completed",link: "project/17"},
  {id:18, img: Image18, 
    name: "Wynn Al Marjan Island", span: "The UAE's first integrated resort and casino, developed by Wynn Resorts on Al Marjan Island in Ras Al Khaimah"
    ,status: "active", link: "project/18"},
  {id:7, img: Image7, 
    name: "Arjaan Burjuman Hotel", span:"A premium hotel managed under the Arjaan by Rotana brand within the Burjuman development in Bur Dubai"
    ,status: "completed", link: "project/19"},
  {id:20, img: Image20, 
    name: "Ahmed Seddiqui WH", span: "A large-scale warehousing and logistics facility for Ahmed Seddiqui & Sons — one of the UAE's most established retail"
    , status: "completed",link: "project/20"},
  {id:21, img: Image21, 
    name: "Eden House", span: "A boutique luxury residential development on Palm Jumeirah offering high-end apartments with premium finishes and full resort-style amenities"
    ,status: "completed", link: "project/21"},
  {id:22, img: Image22, 
    name: "Fly Dubai", span: "Corporate headquarters of flydubai — the UAE's government-owned low-cost airline operating to 100+ destinations"
    ,status: "completed", link: "project/22"},
  {id:23, img: Image23, 
    name: "Mobility Pavilion Expo", span: "One of three landmark thematic pavilions at Expo 2020 Dubai, dedicated to the future of mobility and transportation"
    , status: "completed",link: "project/23"},
  {id:24, img: Image24, 
    name: "IKEA Festival Plaza", span: "IKEA's flagship Dubai store at Festival Plaza — one of the largest IKEA outlets in the Middle East at 64,000 sqm"
    ,status: "completed", link: "project/24"},
  {id:25, img: Image25, 
    name: "Dubai Tram", span:"The 10.6 km Dubai Tram network connecting Jumeirah Beach Residence and Dubai Marina — the first tram network"
    , status: "completed",link: "project/25"},
  {id:26, img: Image26, 
    name: "D1 Tower", span:"A landmark supertall residential tower on Dubai Creek forming part of the Mohammed Bin Rashid City development"
    ,status: "completed", link: "project/26"},
  {id:27, img: Image27, 
    name: "Masdar HQ", span: "The headquarters building of Masdar City — Abu Dhabi's pioneering sustainable urban development and clean energy initiative"
    , status: "completed",link: "project/27"},
  {id:28, img: Image28, 
    name: "Airport Concourse 4", span: "One of Dubai's premier multi-sport facilities, home to major athletics, cycling and indoor sports events."
    ,status: "completed", link: "project/28"},
  {id:29, img: Image29, 
    name: "Hamdan Sports Complex", span: "One of Dubai's premier multi-sport facilities, home to major athletics, cycling and indoor sports events."
    , status: "completed",link: "project/29"},
  {id:30, img: Image30, 
    name: "Caesars Hotel", span:"A luxury hotel marking Caesars Palace's first presence in the Middle East, located on Bluewaters Island adjacent to the Ain Dubai observation wheel"
    , status: "completed",link: "project/30"},
  {id:31, img: Image31, 
    name: "City Walk", span: "A premium open-air retail and lifestyle destination developed by Meraas, spanning 400,000+ sqm in the heart of Dubai"
    ,status: "completed", link: "project/31"},
  {id:32, img: Image32, 
    name: "Marsa Al Seef", span: "A heritage-inspired waterfront promenade and hospitality development along Dubai Creek, developed by Meraas"
    , status: "completed",link: "project/32"},
  {id:33, img: Image33, 
    name: "Il Primo Tower", span: "One of the tallest and most prestigious residential towers in Downtown Dubai"
    , status: "completed",link: "project/33"},
  {id:34, img: Image34, 
    name: "Al Maktoum Airport", span: "The future hub of Dubai's aviation ambitions — planned to become the world's largest airport with a capacity of 260 million passengers per annum"
    , status: "completed",link: "project/34"},
  {id:35, img: Image35, 
    name: "Al Wasl Tower", span:"A prominent commercial and mixed-use tower on Sheikh Zayed Road forming part of the Al Wasl development"
    , status: "completed",link: "project/35"},
  {id:36, img: Image36, 
    name: "Danat Al Emarat Hospital", span:"A specialist hospital in Abu Dhabi providing advanced maternity, women's health and paediatric care"
    ,status: "completed", link: "project/36"},
  {id:37, img: Image37, 
    name: "Deira City Center", span: "One of Dubai's oldest and most established regional shopping malls, developed by Majid Al Futtaim."
    , status: "completed",link: "project/37"},
  {id:38, img: Image38, 
    name: "Dubai Festival City", span: "A 1.7 km waterfront mixed-use development along the Dubai Creek developed by Al Futtaim Group. Dubai Festival City"
    , status: "completed",link: "project/38"},
  {id:39, img: Image39, 
    name: "Dubai Safari",span: "Dubai's flagship wildlife park and conservation centre, spanning over 119 hectares and home to 3,000+ animals from 78 species."
    ,status: "completed", link: "project/39"},
  {id:40, img: Image40, 
    name: "Expo Village", span: "The residential accommodation campus built for Expo 2020 Dubai participants"
    ,status: "completed", link: "project/40"},
  {id:41, img: Image41, 
    name: "Marsa Al Arab", span:"A landmark ultra-luxury resort development extending the iconic Jumeirah Beach Hotel precinct"
    , status: "completed",link: "project/41"},
  {id:42, img: Image42, 
    name: "Princess Tower", span: "One of the world's tallest residential towers at 414 metres — a defining landmark on the Dubai Marina skyline"
    ,status: "completed", link: "project/42"},
  {id:43, img: Image43, 
    name: "RIU Hotel", span: "A beachfront hotel property operated by RIU Hotels & Resorts — one of the world's top 20 hotel chains by room count"
    , status: "completed",link: "project/43"},
  {id:5, img: Image5, 
    name: "Al Nasr Stadium", span:"A sports stadium in Dubai serving as the home ground of Al Nasr FC — one of the UAE's most decorated and supported football clubs"
    , status: "completed",link: "project/44"},
  {id:45, img: Image45, 
    name: "Yas Mall (East Side)", span:"The eastern extension of Yas Mall — Abu Dhabi's largest shopping centre, located on Yas Island adjacent to Ferrari World"
    , status: "completed",link: "project/45"},
  {id:46, img: Image46, 
    name: "Dubai Hills Regional Mall", span:"A major regional shopping destination at the heart of the Dubai Hills Estate master community developed by Emaar and Meraas"
    , status: "completed",link: "project/46"},
  {id:47, img: Image47, 
    name: "Sheikh Khalifa Specialty Hospital RAK", span:"A government-operated specialist hospital in Ras Al Khaimah providing advanced healthcare services to the emirate's residents"
    , status: "completed",link: "project/47"},
];

const Project = () => {
  const [visibleCount, setVisibleCount] = useState(6);
  const [filter, setFilter] = useState("completed");

  const filteredProjects = projects.filter(
    (project) => project.status === filter
  );
  return (
    <div className='project_work' id="workBanner">
      <div className="container project_ourwork">

        {/* Filter Buttons */}
        <div className="project_filter">
          <button
            className={filter === "completed" ? "active" : ""}
            onClick={() => {
              setFilter("completed");
              setVisibleCount(6);
            }}
          >
            Completed
          </button>

          <button
            className={filter === "active" ? "active" : ""}
            onClick={() => {
              setFilter("active");
              setVisibleCount(6);
            }}
          >
            Active
          </button>
        </div>

        {/* <div className="heading">
          <h1>Our Projects</h1>
          <br/>
        </div> */}

       <div className="project_row">
          <div>
            <div className="project_col_12">
              {filteredProjects.slice(0, visibleCount).map((item) => (
                <Link
                  className="project_card"
                  key={item.id}
                  to={item.link}
                >
                  <p className="project_name">{item.name}</p>
                  <p className="project_span">{item.span}</p>

                  <img
                    className="project_image"
                    src={item.img}
                    alt={item.name}
                    loading="lazy"
                  />
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Load More Button */}
        {visibleCount < filteredProjects.length && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button
              onClick={() => setVisibleCount((prev) => prev + 6)}
              className="load_more_btn"
            >
              Load More
            </button>
          </div>
        )}

      </div>
    </div>
  );
};

export default Project;